var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramHealthInsurance48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "68px",
    viewBox: "0 0 52 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.8912215,0 C33.9149923,0 37.9875632,4.01408903 37.9875632,8.96571878 C37.9875632,11.6235512 36.8142134,14.0112684 34.9502208,15.653095 L20.9203183,31.0102557 L7.03430575,15.7575295 C5.10041761,14.1133969 3.87628196,11.6804611 3.87628196,8.96571878 C3.87628196,4.01408903 7.94885284,0 12.9726236,0 C16.39766,0 19.380574,1.86576847 20.9322398,4.62238342 C22.4832712,1.86576847 25.4661852,0 28.8912215,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NETBANK-COLLECTION-new",
    transform: "translate(-663.000000, -1824.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(665.000000, 1826.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Security64",
    stroke: "#4F4C4D",
    strokeWidth: 2.6595072
  }, /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(0.643675, 0.234064)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-3",
    fill: "#FFFFFF",
    points: "0 0 47.3979137 0 47.3979137 48.7145224 23.6989569 63.1972183 0 48.7145224"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Focus",
    fill: "#FFCC00",
    points: "23.6989569 0 47.3979137 3.36311054e-14 47.3979137 28.9653917 23.6989569 28.9653917"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.6989569,
    y1: 2.63321743,
    x2: 23.6989569,
    y2: 61.8806096,
    id: "Vert-Bar",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.7646963,
    y1: 28.9653917,
    x2: 2.63064593,
    y2: 28.9653917,
    id: "Mid-bbar",
    strokeLinecap: "square"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Health64*",
    transform: "translate(3.745020, 13.107571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Health",
    transform: "translate(0.414672, 0.468760)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    stroke: "#4F4C4D",
    strokeWidth: 2.34118546,
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-5",
    stroke: "#4F4C4D",
    strokeWidth: 2.570112,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "-2.75426399e-15 15.5051278 16.2803842 15.5051278 19.3814098 10.0783331 22.4824354 20.9319226 25.5834609 15.5051278 40.3133324 15.5051278"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramHealthInsurance48);
export default __webpack_public_path__ + "static/media/pictogramHealthInsurance48.a1e4157043cd18d42373e410d219f738.svg";
export { ForwardRef as ReactComponent };